<template>
<span>
    <input ref="file"
           style="display: none"
           type="file"
           accept="text/plain"
           @change="readFile">
    <div class="odr-textarea__file">
        <text-link bold="true" @click="$refs.file.click()">
            <icon>insert_drive_file</icon> {{ $trl('aw.textarea_file_title') }}
        </text-link>
    </div>
    <inputarea
        ref="field"
        :min-width-desktop="minWidthDesktop"
        :value="input"
        :lastpass="lastpass"
        :data-qa="dataQa"
        :focused="focused"
        :invalid="highlightInvalid"
        :min-height="minHeight"
        :max-height="maxHeight"
        :max-width="maxWidth"
        :has-clear="hasClear"
        :min-size="minSize"
        :textarea-style="true"
        @value="onInput"
        @blur="() => {$emit('blur')}"
        @focus="() => {$emit('focus')}"/>

    <div v-if="validation_showError && validation_error"
         :data-qa="`${dataQa}.error`"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">{{ validation_error }}</div>
</span>
</template>

<script>
import '@/scss/blocks/error-message.scss';
import '@/scss/blocks/textarea.scss';

import validationMixin from '@/utils/mixins/validation';
import inputarea from '@/vue/components/inputarea.vue';

export default {
    mixins: [validationMixin],
    props: {
        minWidthDesktop: {},
        dataQa: {},
        value: {},
        title: {},
        icon: {},
        placeholder: {},
        lastpass: {},
        focused: {},
        autocomplete: {},
        minSize: {},
        hasClear: {},
        validationPattern: {},
        keyboard: {},
        invalid: {},
        patternInvalidPrompt: {},
        minHeight: {
            default: 100,
        },
        maxHeight: {
            default: 400,
        },
        maxWidth: {},
    },
    data () {
        return {
            input: this.value,
            fileError: false,
        };
    },
    computed: {
        highlightInvalid () {
            return this.invalid || (this.validation_error && this.validation_showError);
        },
    },
    watch: {
        value (value) {
            this.setInput(value);
        },
    },
    methods: {
        readFile () {
            let file = this.$refs.file.files[0];
            if (file) {
                let reader = new FileReader();
                reader.readAsText(file, 'UTF-8');
                reader.onloadend = (event) => {
                    this.input = event.target.result;
                    this.fileError = false;
                };
                reader.onerror = () => {
                    this.fileError = true;
                };
            }
        },
        validation_isEmpty () {
            return !(this.input && this.input.trim());
        },
        validation_focusError () {
            this.$emit('focus');
        },
        validation_invalid () {
            if (this.fileError) {
                return this.$trl('aw.textarea_file_invalid');
            }
        },
        onInput (value) {
            this.setInput(value);
        },
        setInput (value) {
            this.input = value;
            this.fileError = false;
            this.$emit('input', this.input);
            this.$forceUpdate();
            this.validation_changed();
        },
    },
    components: {
        inputarea,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
        'text-link': require('@clearwave/odoro-markup/lib/vue/text-link.vue').default,
    },

};
</script>
